module.exports = __webpack_public_path__ + "img/Info_center1.f7d0ee04.jpg";